import React from 'react';
import { Star } from 'lucide-react';
import { useWatchlist } from '../contexts/WatchlistContext';

export const WatchlistButton = ({ company, sourceModule = '', size = 'sm' }) => {
  const { toggle, isWatched } = useWatchlist();
  const watched = isWatched(company);
  const sz = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';

  return (
    <button
      data-testid={`watchlist-btn-${company.replace(/\s+/g, '-').toLowerCase()}`}
      onClick={(e) => { e.stopPropagation(); toggle(company, sourceModule); }}
      className={`transition-all duration-200 ${watched ? 'text-amber-500 hover:text-amber-600' : 'text-gray-300 hover:text-amber-400'}`}
      title={watched ? 'Remove from watchlist' : 'Add to watchlist'}
    >
      <Star className={`${sz} ${watched ? 'fill-current' : ''}`} />
    </button>
  );
};
